import React from 'react';
import { PartnerMyInfoPage } from '../components/integration/PartnerMyInfoPage';

interface UserInfo {
  username: string;
  displayName: string;
  role: string;
  orgName: string;
  orgIcon: string;
  loginTime: string;
}

export default function EINSMyInfo({ user }: { user: UserInfo }) {
  return <PartnerMyInfoPage partner="EINS" user={user} />;
}
